// Configuration de l'API
// URL locale dynamique : suit le hostname courant (127.0.0.1 en local,
// focuspips-server via Tailscale, etc.) — jamais l'IP du poste client.
const LOCAL_URL = (typeof window !== 'undefined' && window.location?.hostname)
  ? `${window.location.protocol}//${window.location.hostname}:3001`
  : 'http://127.0.0.1:3001';
const PRODUCTION_URL = 'https://focuspips.com';

// Obtenir l'URL de base actuelle
export const getApiMode = (): 'local' | 'production' => {
    if (typeof window !== 'undefined') {
        const stored = localStorage.getItem('api_mode') as 'local' | 'production' | null;
        if (stored === 'local' || stored === 'production') {
            return stored;
        }
        // En dev local sans override explicite → proxy local (évite CORS vers la prod)
        const host = window.location.hostname;
        if (host === 'localhost' || host === '127.0.0.1' || host === 'focuspips-server' || host.endsWith('.ts.net')) {
            return 'local';
        }
        // Sécurité : un serveur de dev ne doit JAMAIS appeler la prod par accident
        if (import.meta.env.DEV) {
            return 'local';
        }
    }
    return 'production';
};

// Fonction pour définir le mode API
export const setApiMode = (mode: 'local' | 'production'): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('api_mode', mode);
        // Déclencher un événement personnalisé pour notifier les composants
        window.dispatchEvent(new CustomEvent('api-mode-changed', { detail: mode }));
    }
};

// Obtenir l'URL de base actuelle
export const getApiBaseUrl = (): string => {
    return getApiMode() === 'production' ? PRODUCTION_URL : LOCAL_URL;
};

// Export pour compatibilité avec le code existant
export const API_BASE_URL = getApiBaseUrl();

// Helper function pour construire les URLs de l'API
export const getApiUrl = (endpoint: string): string => {
    const baseUrl = getApiBaseUrl();
    return `${baseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};
